import type { Resource } from '../../';
export const forms_address_country: Resource = {"default":"Country"};
